import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

/**
 * Detects and fixes double/trailing slashes in the current pathname.
 *
 * Uses segment-based normalization instead of simple regex replacement to handle
 * pathological cases like '////' that can result from S3 directory-style redirects
 * or cached bad redirects in embedded WebViews (WhatsApp, Facebook, etc.).
 */
const TrailingSlashNormalizer = (): null => {
    const { pathname, search, hash } = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        if (typeof window === 'undefined') return;

        const hasMultipleSlashes = /\/\//.test(pathname);
        const hasTrailingSlash = pathname.length > 1 && pathname.endsWith('/');

        if (hasMultipleSlashes || hasTrailingSlash) {
            // Segment-based: split on '/', discard empty parts, rejoin
            const cleaned = '/' + pathname.split('/').filter(Boolean).join('/');
            if (cleaned !== pathname) {
                navigate(cleaned + search + hash, { replace: true });
            }
        }
    }, [pathname, search, hash, navigate]);

    return null;
};

export default TrailingSlashNormalizer;
